import React from 'react';
import { connect } from 'react-redux';
import { pending, rejected } from 'redux-saga-thunk';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import get from 'lodash/get';
import { createValidator, required } from '../services/validation';
import { authLoginRequest } from '../store/auth/actions';
import { getToken } from '../store/auth/selectors';
import LoginForm from '../components/molecules/LoginForm';

const LoginFormContainer = props => <LoginForm {...props} />;

const onSubmit = (values, dispatch, props) => props.loginRequest(values);

const validate = createValidator({
  username: [required],
  password: [required],
});

const mapStateToProps = state => ({
  referrer: localStorage.getItem('redirectTo'),
  loading: pending(state, 'userLoginCreate'),
  authError:
    get(state, 'auth.error', false) ||
    (rejected(state, 'userLoginCreate') ? 'Unable to sign in right now' : false),
  isAuthenticated: getToken(state),
});

const mapDispatchToProps = dispatch => ({
  loginRequest: options => dispatch(authLoginRequest(options)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'LoginForm',
    onSubmit,
    validate,
  })
)(LoginFormContainer);
